<template>
	<form ref="form" :action="action" :method="method" @submit.prevent="onSubmit">
		<div class="md:flex md:items-center mb-6">
			<div class="md:w-1/5">
				<label class="block text-gray-500 font-bold" for="name">{{ t('name') }}</label>
			</div>
			<div class="md:w-4/5">
				<div v-if="edit">
					<input ref="name" name="name" class="input text-primary placeholder-secondary-200" v-model="form.name" v-validate="{ required: true , min:3 ,max:255 }" :class="{'border-red-500': errors.has('name') }" type="text" :placeholder="t('name')">
					<p v-show="errors.has('name')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('name') }}</p>
				</div>
				<div v-else>
					<p class="text-black">{{userObject.name}}</p>
				</div>
			</div>
		</div>
		<div class="md:flex md:items-center mb-6">
			<div class="md:w-1/5">
				<label class="block text-gray-500 font-bold" for="email">{{ t('email') }}</label>
			</div>
			<div class="md:w-4/5">
				<div v-if="edit">
					<input ref="email" email="email" class="input text-primary placeholder-secondary-200" v-model="form.email" v-validate="{ required: true }" :class="{'border-red-500': errors.has('email') }" type="email" :placeholder="t('email')">
					<p v-show="errors.has('email')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('email') }}</p>
				</div>
				<div v-else>
					<p class="text-black">{{userObject.email}}</p>
				</div>
			</div>
		</div>
		<div class="md:flex md:items-center mb-6">
			<div class="md:w-1/5">
				<label class="block text-gray-500 font-bold" for="phone">{{ t('phone') }}</label>
			</div>
			<div class="md:w-4/5">
				<div v-if="edit">
					<input ref="phone" name="phone" class="input text-primary placeholder-secondary-200" v-model="form.phone" v-validate="{ required: true ,digits:11 }" :class="{'border-red-500': errors.has('phone') }" type="text" :placeholder="t('phone')">
					<p v-show="errors.has('phone')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('phone') }}</p>
				</div>
				<div v-else>
					<p class="text-black">{{userObject.phone}}</p>
				</div>
			</div>
		</div>
		<div class="md:flex md:items-center mb-6" v-if="edit">
			<div class="md:w-1/5">
				<label class="block text-gray-500 font-bold" for="password">{{ t('password') }}</label>
			</div>
			<div class="md:w-4/5">
				<input autocomplete="off" name="password" class="text-primary placeholder-secondary-200 input" v-model="form.password" :class="{'border-red-500': errors.has('password') }" :type="passwordFieldType" :placeholder="t('password')" @blur="checkPassword($event,checkPass,'password')">
				<p v-show="errors.has('password')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('password') }}</p>
				<p ref="password" class="text-red-500 text-sm mt-3 text-center hidden"></p>
			</div>
		</div>
		<div class="md:flex md:items-center mb-6" v-if="edit">
			<div class="md:w-1/5">
				<label class="block text-gray-500 font-bold" for="new_password">{{ t('new_password') }}</label>
			</div>
			<div class="md:w-4/5">
				<input name="new_password" class="text-primary placeholder-secondary-200 input" v-model="form.new_password" v-validate="newPassRequired" :class="{'border-red-500': errors.has('new_password') }" :type="passwordFieldType" :placeholder="t('new_password')" ref="new_password">
				<p v-show="errors.has('new_password')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('new_password') }}</p>
			</div>
		</div>
		<div class="md:flex md:items-center mb-6" v-if="edit">
			<div class="md:w-1/5">
				<label class="block text-gray-500 font-bold" for="new_password_confirmation">{{  t('new_password_confirmation') }}</label>
			</div>
			<div class="md:w-4/5">
				<input name="new_password_confirmation" class="text-primary placeholder-secondary-200 input" v-model="form.new_password_confirmation" v-validate="newPassConfRequired" :class="{'border-red-500': errors.has('new_password_confirmation') }" :type="passwordFieldType" :placeholder=" t('new_password_confirmation') " ref="new_password_confirmation">
				<p v-show="errors.has('new_password_confirmation')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('new_password_confirmation') }}</p>
			</div>
		</div>
		<div class="md:flex md:items-center mb-6">
			<div class="md:w-1/5">
				<label class="block text-gray-500 font-bold" for="country">{{ t('country') }}</label>
			</div>
			<div class="md:w-4/5">
				<div v-if="edit">
					<input ref="country" name="country" class="input text-primary placeholder-secondary-200" v-model="form.country" v-validate="{ required: true , min:3 ,max:255 }" :class="{'border-red-500': errors.has('country') }" type="text" :placeholder="t('country')">
					<p v-show="errors.has('country')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('country') }}</p>
				</div>
				<div v-else>
					<p class="text-black">{{userObject.country}}</p>
				</div>
			</div>
		</div>
		<div class="md:flex md:items-center mb-6">
			<div class="md:w-1/5">
				<label class="block text-gray-500 font-bold" for="city">{{ t('city') }}</label>
			</div>
			<div class="md:w-4/5">
				<div v-if="edit">
					<input ref="city" name="city" class="input text-primary placeholder-secondary-200" v-model="form.city" v-validate="{ required: true , min:3 ,max:255 }" :class="{'border-red-500': errors.has('city') }" type="text" :placeholder="t('city')">
					<p v-show="errors.has('city')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('city') }}</p>
				</div>
				<div v-else>
					<p class="text-black">{{userObject.city}}</p>
				</div>
			</div>
		</div>
		<div class="md:flex md:items-center mb-6">
			<div class="md:w-1/5">
				<label class="block text-gray-500 font-bold" for="area">{{ t('area') }}</label>
			</div>
			<div class="md:w-4/5">
				<div v-if="edit">
					<input ref="area" name="area" class="input text-primary placeholder-secondary-200" v-model="form.area" v-validate="{ required: true , min:3 ,max:255 }" :class="{'border-red-500': errors.has('area') }" type="text" :placeholder="t('area')">
					<p v-show="errors.has('area')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('area') }}</p>
				</div>
				<div v-else>
					<p class="text-black">{{userObject.area}}</p>
				</div>
			</div>
		</div>
		<div class="flex">
			<div class="w-1/2 m-auto mt-8 text-center" v-if="edit">
				<button type="submit" class="button bg-secondary-200 hover:bg-primary text-white">
					{{ t('confirm') }}
				</button>
			</div>
			<div :class="{'w-1/2 m-auto mt-8 text-center':edit , 'w-full m-auto text-center mt-8':!edit} ">
				<a href="#" class="button bg-secondary-200 hover:bg-primary text-white" @click="editFun()">
					{{edit == false ? t('edit'): t('cancel')}}
				</a>
			</div>
		</div>
	</form>
</template>
<script>

import axios from 'axios';
import arabic from 'vee-validate/dist/locale/ar';
import { Validator , mapFields} from 'vee-validate';
import trans from './translation/user.json';
export default {
	name: 'Profile',
	props: {
		method: {
			type: String,
			required: true
		},
		action: {
			type: String,
			required: true
		},
		sitelocale:{
			type: String,
			required: true
		},
		userObject:{
			type: Object,
			required: true
		},
		checkPass: {
			type: String,
			required: true
		}
	},
	data: () => ({
		submitting: false,
		success: false,
		form : {
			name: '',
			password:'',
			new_password:'',
			new_password_confirmation:'',
			phone:'',
			email: '',
			country: '',
			city: '',
			area: ''
			
		},
		passwordFieldType: 'password',
		phone: {
			number: '',
			isValid: true,
			country: undefined,
		},
		edit:false,
	}),
	mounted() {
		this.$translate.setLang(this.sitelocale);
			// this.choosed = this.accountData.corporation.accountTypes[0].name
		},
		locales: trans,
		created() {
			this.form.name = this.userObject.name;
			this.form.email = this.userObject.email;
			this.form.phone = this.userObject.phone;
			this.phone.number = this.userObject.phone;
			this.form.country = this.userObject.country;
			this.form.city = this.userObject.city;
			this.form.area = this.userObject.area;
			this.$validator.localize('ar', {
				messages: arabic.messages,
				attributes: trans.ar,
				custom:trans.ar.custom
			});
			this.$validator.localize('en', {
				custom:trans.en.custom
			});
			
			Validator.localize(this.sitelocale);
			console.log(this.action);
		},
		methods: {
			editFun(){
				this.edit = !this.edit
				if(this.edit == false){
					this.form.name= this.userObject.name;
					this.form.email=this.userObject.email;
					this.form.phone= this.userObject.phone;
					this.form.country= this.userObject.country;
					this.form.city= this.userObject.city;
					this.form.area= this.userObject.area;
					this.phone.number= this.userObject.phone;
				}
			},
			checkPassword(data,route,fieldname){
				const input = data.target;
				data =  data.target.value;
				let message = this.$refs[fieldname];
				if(!this.errors.has(fieldname) && data){
					axios.post(route, {'password' : data })
					.then( response => {
						input.classList.remove('is-danger');
						this.$refs[fieldname].classList.add('hidden');
						message.innerHTML = "";
					})
					.catch(error => {
						console.log(error);
						input.classList.add('is-danger');
						message.innerHTML = error.response.data.data;
						this.$refs[fieldname].classList.remove('hidden');
					});
				}
			},
			onSubmit(){
				this.$validator.validateAll().then((result) => {
					if (result) {			
						const data = new FormData(this.$refs.form);
						this.submitting = true;
						const method = this.method;
						const action = this.action;
						axios.post(action, this.form)
						.then( response => {
							this.$toasted.success(response.data.data);
							this.success = true;
							setTimeout(function() {
								window.location.reload();
							}, 1000);
						})
						.catch(error => {
							let toaster = this.$toasted;
							$.each(error.response.data.errors, function(key, value) {
								toaster.error(value.message);
							});
							this.success = false;

						})
						.then(()=>{
							this.submitting = false;
							setTimeout(()=>{
								this.success = false;
							}, 3500);
						});

					}

				});

			},
			clearInputs(){
				let inputs = document.querySelectorAll(".form-block .form-element");

				$.each(inputs, function(key, value) {
					console.log(value.tagName);
					if(value.tagName  == 'INPUT' || value.tagName  == 'TEXTAREA'){
						value.value ="";
					}else{
						value.innerHTML="";
					}


				});
			},
		},
		computed: {
			passwordRequired(){
				return this.form.password.length > 0 ? 'min:6' : '';
			},
			newPassRequired() {
				return this.form.password.length > 0 ? 'required|min:6' : '';
			},
			newPassConfRequired() {
				return this.form.new_password.length > 0 ? 'required|min:6|confirmed:new_password' : '';
			}
		}
	};
	</script>
	<style type="text/css">
	.hidden{
		display: none;
	}
	</style>


// WEBPACK FOOTER //
// resources/assets/js/front/components/Profile.vue